module.exports = __webpack_public_path__ + "img/img_privacy.dccbf40e.png";